<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    height="192.4"
    preserveAspectRatio="xMidYMid meet"
    version="1.1"
    viewBox="139.2 116.4 146.9 192.4"
    width="146.9"
    zoomAndPan="magnify"
  >
    <defs>
      <clipPath id="clip1">
        <path d="m71 0h354.2v347h-354.2z" />
      </clipPath>
    </defs>
    <g id="surface1">
      <path
        d="m1710.2 2958.8h-257.7s-35.7-526.6 384-471.4"
        fill="none"
        stroke="#fabb4c"
        stroke-miterlimit="10"
        stroke-width="120"
        transform="matrix(.1 0 0 -.1 0 425.2)"
      />
      <g clip-path="url(#clip1)">
        <path
          d="m2541.8 2958.8h257.7s35.7-526.6-384-471.4"
          fill="none"
          stroke="#fabb4c"
          stroke-miterlimit="10"
          stroke-width="120"
          transform="matrix(.1 0 0 -.1 0 425.2)"
        />
      </g>
      <g id="change1_1">
        <path
          d="m166.94 116.39v34.76c1.59 60.96 40.41 60.55 40.41 60.55v37.6h10.5v-37.6s38.82 0.41 40.42-60.55v-34.76h-91.33"
          fill="#fabb4c"
        />
      </g>
      <g id="change1_2">
        <path
          d="m217.85 249.3h-10.5l-13.7 12.27h37.9l-13.7-12.27"
          fill="#fabb4c"
        />
      </g>
      <g id="change2_1">
        <path d="m257.62 300.22h-90.04v-38.65h90.04v38.65" fill="#3d4176" />
      </g>
      <g id="change3_1">
        <path d="m266.86 308.81h-109.09v-8.59h109.09v8.59" fill="#2c2d53" />
      </g>
      <g id="change1_3">
        <path d="m236.55 291.33h-47.9v-20.86h47.9v20.86" fill="#fabb4c" />
      </g>
      <g id="change4_1">
        <path
          d="m212.6 131.35l7.06 14.31 15.81 2.3-11.44 11.15 2.7 15.73-14.13-7.43-14.13 7.43 2.7-15.73-11.44-11.15 15.81-2.3 7.06-14.31"
          fill="#fff766"
        />
      </g>
    </g>
  </svg>
</template>
